import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, IconButton, Typography, Button, Card, CardContent, TextField, List, Box, ListItem, ListItemText, DialogActions, Divider, Container, FormLabel, Dialog, DialogTitle, DialogContent, Grid } from "@mui/material";
import { ArrowBack, Remove, Add, Delete, Discount, ArrowForward } from "@mui/icons-material";
import GroupedCartPopup from "./modals/groupedCartItems";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const CartOlympiad = ({ payload, series, initialCartItems, proceed, setCart, seriesD, editMode, newDataProp, isSpecimen, tntAmount, attachments1, subjects = [] }) => {
    const [cartItems, setCartItems] = useState([]);
    const [discountPopup, setDiscountPopup] = useState(false);
    const [discounts, setDiscounts] = useState({})
    const [open, setOpen] = useState(false);
    const [files, setFiles] = useState([]);
    const [attachments, setAttachment] = useState([]);
    const [tentativeAmount, setTentativeAmount] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedPdf, setSelectedPdf] = useState(null);
    console.log(payload, "cart ka payloadpayloadpayloadpayload")
    const parsedAttachments = React.useMemo(() => {
        if (!attachments1) return [];
        let value = attachments1;
        try {
            if (typeof value === "string") {
                value = JSON.parse(value);
            }
            if (typeof value === "string") {
                value = JSON.parse(value);
            }
            if (Array.isArray(value)) return value;
            if (typeof value === "object") return [value];
        } catch (err) {
            console.error("Attachment parse failed:", attachments1, err);
        }
        return [];
    }, [attachments1]);

    const handleQuantityChange = (index, delta) => {
        setCartItems((prev) => {
            const updated = prev.map((item, i) =>
                i === index ? { ...item, qty: Math.max(1, item.qty + delta) } : item
            );
            const id = updated[index].itemId;
            const temp = initialCartItems.map((item) =>
                item.data.skuId === id
                    ? { ...item, quantity: Math.max(1, item.quantity + delta) }
                    : item
            );
            setCart(temp);
            return updated;
        });
    };

    const handleRemoveItem = (index) => {
        const id = cartItems[index].itemId;
        setCartItems((prev) => prev.filter((_, i) => i !== index));
        const temp = initialCartItems.filter(
            (item) => item.data.skuId !== id
        );
        setCart(temp);
    };

    const getTotalPrice = () => {
        return cartItems.reduce((total, item) => total + (item.price * item.qty) * (1 - item.discount / 100), 0);
    };

    function setData() {
        const newCartItems = [];
        initialCartItems.forEach((order) => {
            const quantity = parseInt(order.quantity, 10) || 1;
            const group = order.group;
            const item = order.data || {};

            newCartItems.push({
                name: item?.nameSku,
                sku_code: item?.sku_code,
                productGroup: group,
                bookType: order.bookType || "",
                class: order.class || "",
                price: item.unitPrice != null ? parseFloat(item.unitPrice) : parseFloat(item.landing_cost) || 0.0,
                qty: quantity,
                series: item.seriesCategory || "",
                itemId: item.skuId || item.id,
                total: item.unitPrice != null ? (parseFloat(item.unitPrice) * quantity || 0.0) : 0.0,
                discount: item.discount ? item.discount : 0,
                itemType: order.orderType,
            });
        });
        setCartItems(newCartItems);
    }

    useEffect(() => { setData() }, [])

    useEffect(() => {
        if (seriesD) {
            let parsed = seriesD;
            if (typeof seriesD === 'string') {
                try {
                    parsed = JSON.parse(seriesD);
                } catch (e) {
                    parsed = {};
                }
            }
            setDiscounts(parsed || {});
        }
    }, [seriesD]);

    useEffect(() => {
        if (cartItems.length === 0) return;
        setCartItems((prev) =>
            prev.map((item) => ({ ...item, discount: discounts[item.series] ?? item.discount ?? 0 }))
        );
    }, [discounts]);

    useEffect(() => {
        setTentativeAmount(tntAmount || "")
    }, [editMode])

    function applyD(discountsObj) {
        let temp = [...cartItems];
        temp.forEach((ele) => {
            ele.discount = discountsObj[ele.series] ?? 0;
        });
        setDiscountPopup(false);
        setCartItems(temp);
        setDiscounts(discountsObj || {});
    }

    function payloadCreate() {
        if (!editMode && payload?.orderProcess == "upload" && (payload?.orderType?.toLowerCase() == "specimen" || payload?.orderType === "Sales" || payload?.orderType === "saleS") && attachments == "") {
            alert("Please upload attachment before proceeding.")
            return;
        }
        if (payload?.orderType?.toLowerCase() != "specimen" && payload?.applyDiscount == "yes") {
            let seriesList = [];
            if (payload?.orderProcess == "upload" && payload?.uploadSeries) {
                seriesList = Array.isArray(payload.uploadSeries) ? payload.uploadSeries : [payload.uploadSeries];
            } else {
                seriesList = [...new Set(cartItems.map(item => item.series).filter(Boolean))];
            }
            if (payload && payload?.orderType !== "Specimen" && payload?.orderProcess == "upload" && tentativeAmount == "" && tentativeAmount < 0) {
                alert("Please Enter Tentative Amount");
                return;
            }
            if (payload && payload?.orderType !== "Specimen" && payload?.orderProcess === "upload" && (!tentativeAmount || Number(tentativeAmount) <= 0)) {
                alert("Please enter Tentative Amount");
                return;
            }

            const allSeriesHaveDiscount = seriesList.length > 0 &&
                seriesList.every(series => (discounts[series] ?? 0) >= 0);

            if (!allSeriesHaveDiscount) {
                alert("Discount must be filled for all series");
                return;
            }
        }
        var body = { ...payload };
        body['totalAmount'] = body['orderType'].toLowerCase() == 'sales' ? getTotalPrice() : 0;
        body['seriesDiscount'] = discounts;
        body['attachments'] = attachments || attachments1 || [];
        body['tentativeAmount'] = tentativeAmount;
        body['amountToPay'] = Number((registrationTotal + studyMaterialTotal).toFixed(2));
        body['orders'] = cartItems.map((item) => {
            return {
                'itemId': item.itemId,
                'name': item.name,
                'price': item.price,
                'qty': item.qty,
                'productGroup': item.productGroup,
                'orderType': item.itemType ?? "",
                'total': payload['orderType'].toLowerCase() == 'sales' ? item.price * item.qty * (1 - item.discount / 100) : 0,
                'class': item.class || "",
                'bookType': item.bookType || "",
            };
        });
        proceed(cartItems, body)
    }

    const getFilePreview = (file) => {
        if (file.type.startsWith('image/')) {
            return <img src={URL.createObjectURL(file)} alt={file.name} style={{ maxWidth: '100%', height: '100px' }} />;
        } else {
            return <InsertDriveFileIcon style={{ fontSize: 50, height: "100px", }} />;
        }
    };

    const handleFileChange = (event) => {
        setFiles([...event.target.files]);
        setOpen(true);
    };

    const handleUpload = async () => {
        const formData = new FormData();
        files.forEach((file, index) => {
            formData.append(`files`, file);
        });

        try {
            const response = await window.Platform.database.uploadMultipleImages(formData);
            if (response) {
                const result = await response
                let temp = [...attachments]
                result.data.files.forEach((ele) => {
                    temp.push(ele)
                });
                setAttachment(temp)

                setOpen(false);
            } else {
                alert('Failed to upload files.');
            }
        } catch (error) {
            console.error('Upload error:', error);
            alert('Error uploading files.');
        }
    };

    const handleImageClick = (file) => {
        const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
        window.open(url, "_blank");
        setSelectedImage(file);
        setSelectedPdf(null);
    };

    const handlePdfClick = (file) => {
        const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;
        window.open(url, "_blank");
        setSelectedPdf(file);
        setSelectedImage(null);
    };

    const downloadFile = async (file) => {
        const url = `${window.Platform.database.funcForBaseURL()}/file/${file.fileName}`;

        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = file.originalName || file.fileName || "download";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("Download failed:", err);
        }
    };
    const formatDate = (dateStr) => {
        return new Date(dateStr).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const subjectPriceMap = React.useMemo(() => {
        const normalize = (value) => String(value || "").trim().toLowerCase();
        return (subjects || []).reduce((map, subject) => {
            const key = normalize(subject.subject_name || subject.subjectName);
            map[key] = Number(subject.price || 0) || 0;
            return map;
        }, {});
    }, [subjects]);

    const getSubjectPrice = (subjectName) => {
        const key = String(subjectName || "").trim().toLowerCase();
        return subjectPriceMap[key] || 112.5;
    };

    const registrationFee = Number(payload?.olympiadDetails?.registrationFee || 0) || 0;

    const studyMaterialTotal =
        payload?.olympiadDetails?.classSubjects?.reduce((grand, cls) => {
            return (
                grand +
                cls.subjects.reduce((sum, sub) => {
                    const price = getSubjectPrice(sub.subjectName);
                    return sum + ((sub.materialQty || 0) * price);
                }, 0)
            );
        }, 0) || 0;

    const registrationTotal =
        payload?.olympiadDetails?.classSubjects?.reduce((grand, cls) => {
            return (
                grand +
                cls.subjects.reduce((sum, sub) => {
                    return sum + ((sub.studentCount || 0) * registrationFee);
                }, 0)
            );
        }, 0) || 0;

    const subjectWiseData = React.useMemo(() => {
        const map = {};

        payload?.olympiadDetails?.classSubjects?.forEach((cls) => {
            cls.subjects.forEach((sub) => {
                const subject = sub.subjectName || "Unknown";

                if (!map[subject]) {
                    map[subject] = [];
                }

                map[subject].push({
                    className: cls.className,
                    studentCount: sub.studentCount || 0,
                    materialQty: sub.materialQty || 0,
                });
            });
        });

        return map;
    }, [payload]);

    const totalStudents =
        payload?.olympiadDetails?.classSubjects?.reduce((grand, cls) => {
            return (
                grand +
                cls.subjects.reduce((sum, sub) => {
                    return sum + Number(sub.studentCount || 0);
                }, 0)
            );
        }, 0) || 0;

    const totalStudyMaterial =
        payload?.olympiadDetails?.classSubjects?.reduce((grand, cls) => {
            return (
                grand +
                cls.subjects.reduce((sum, sub) => {
                    return sum + Number(sub.materialQty || 0);
                }, 0)
            );
        }, 0) || 0;

    const regType = Number(payload?.olympiadDetails?.registrationTypeId);

    const showStudentCount = regType === 1 || regType === 2;
    const showMaterialCount = regType === 1 || regType === 3;

    return (
        <Container>
            <div>

                <Card sx={{ p: 2, mb: 2 }}>
                    <Typography style={{ color: "#000", fontSize: "20px", fontWeight: 600 }} gutterBottom> Olympiad Summary </Typography>
                    <Typography><span style={{ fontSize: "15px", fontWeight: "600", color: "black" }}>Registration Type: </span><span style={{ fontSize: "13px", fontWeight: "500", color: "black" }}> {payload?.olympiadDetails?.registrationTypeName}</span></Typography>
                    <Typography><span style={{ fontSize: "15px", fontWeight: "600", color: "black" }}>Medium: </span><span style={{ fontSize: "13px", fontWeight: "500", color: "black" }}> {payload?.olympiadDetails?.mediumName}</span></Typography>
                    <Typography><span style={{ fontSize: "15px", fontWeight: "600", color: "black" }}>Exam Date: </span><span style={{ fontSize: "13px", fontWeight: "500", color: "black" }}> {formatDate(payload?.olympiadDetails?.examDate)}</span></Typography>
                </Card>

                {Object.entries(subjectWiseData).map(([subject, classes], index) => {
                    // let subjectTotal = 0;
                    // 👉 filter classes where BOTH values are 0 or empty
                    const filteredClasses = classes.filter(cls =>
                        Number(cls.studentCount || 0) > 0 ||
                        Number(cls.materialQty || 0) > 0
                    );

                    // ❌ if no valid class, don't render subject at all
                    if (filteredClasses.length === 0) return null;

                    let subjectTotal = 0;

                    return (
                        <Card key={index} sx={{ mb: 3, borderRadius: 3, boxShadow: 2 }}>

                            <Box sx={{ bgcolor: "#f5f7fa", p: 2 }}>
                                <Typography sx={{ fontWeight: 600 }}>
                                    {subject}
                                </Typography>
                            </Box>

                            {/* HEADER */}
                            {/* <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
                                    px: 2,
                                    py: 1,
                                    bgcolor: "#fafafa",
                                    fontWeight: 600,
                                    borderBottom: "1px solid #ccc",
                                }}
                            >
                                <span style={{ textAlign: "center" }}>Class</span>
                                <span style={{ textAlign: "center" }}>Students</span>
                                <span style={{ textAlign: "center" }}>Study Kit</span>
                                <span style={{ textAlign: "center" }}>Amount</span>
                            </Box> */}
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: `2fr ${showStudentCount ? "1fr" : ""} ${showMaterialCount ? "1fr" : ""} 1.5fr`,
                                    px: 2,
                                    py: 1,
                                    bgcolor: "#fafafa",
                                    fontWeight: 600,
                                    borderBottom: "1px solid #ccc",
                                }}
                            >
                                <span style={{ textAlign: "center" }}>Class</span>

                                {showStudentCount && (
                                    <span style={{ textAlign: "center" }}>Students</span>
                                )}

                                {showMaterialCount && (
                                    <span style={{ textAlign: "center" }}>Study Kit</span>
                                )}

                                <span style={{ textAlign: "center" }}>Amount</span>
                            </Box>
                            {/* CLASS ROWS */}
                            {filteredClasses.map((cls, i) => {
                                const price = getSubjectPrice(subject);
                                const total = cls.materialQty * price;
                                subjectTotal += total;

                                return (
                                    // <Box
                                    //     key={i}
                                    //     sx={{
                                    //         display: "grid",
                                    //         gridTemplateColumns: "2fr 1fr 1fr 1.5fr",
                                    //         px: 2,
                                    //         py: 1.5,
                                    //         borderTop: "1px solid #eee",
                                    //         textAlign: "center"
                                    //     }}
                                    // >
                                    //     <Typography>{cls.className}</Typography>
                                    //     <Typography>{cls.studentCount}</Typography>
                                    //     <Typography>{cls.materialQty}</Typography>
                                    //     <Typography>₹{total.toFixed(2)}</Typography>
                                    // </Box>
                                    <Box
                                        key={i}
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: `2fr ${showStudentCount ? "1fr" : ""} ${showMaterialCount ? "1fr" : ""} 1.5fr`,
                                            px: 2,
                                            py: 1.5,
                                            borderTop: "1px solid #eee",
                                            textAlign: "center"
                                        }}
                                    >
                                        <Typography>{cls.className}</Typography>

                                        {showStudentCount && (
                                            <Typography>{cls.studentCount}</Typography>
                                        )}

                                        {showMaterialCount && (
                                            <Typography>{cls.materialQty}</Typography>
                                        )}

                                        <Typography>
                                            ₹{total.toFixed(2)}
                                        </Typography>
                                    </Box>
                                );
                            })}

                            {/* SUBJECT TOTAL */}
                            <Box sx={{ textAlign: "right", p: 2, bgcolor: "#fafafa" }}>
                                <Typography fontWeight="bold">
                                    Subject Total: ₹{subjectTotal.toFixed(2)}
                                </Typography>
                            </Box>
                        </Card>
                    );
                })}

                <Typography variant="h6" align="right">
                    Total Students: {totalStudents}
                </Typography>

                <Typography variant="h6" align="right">
                    Total Study Material: {totalStudyMaterial}
                </Typography>
                <Card sx={{ p: 2, mt: 2 }}>
                    <Typography variant="h6" align="right">
                        Registration Fee: ₹{registrationTotal.toFixed(2)}
                    </Typography>

                    <Typography variant="h6" align="right">
                        Study Material Fee: ₹{studyMaterialTotal.toFixed(2)}
                    </Typography>

                    <Typography variant="h6" align="right" sx={{ fontWeight: "bold" }}>
                        Grand Total: ₹{(registrationTotal + studyMaterialTotal).toFixed(2)}
                    </Typography>
                </Card>

                {/* 🔹 PROCEED BUTTON */}
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        endIcon={<ArrowForward />}
                        onClick={() => payloadCreate()}
                    >
                        Confirm & Proceed
                    </Button>
                </Box>

            </div>
        </Container>
    );
};

export default CartOlympiad;